import { createFileRoute, notFound } from "@tanstack/react-router"

import { PageHeaderSlotProvider } from "@/components/common/page-header-slot"
import { PortalTask } from "@/features/portal/components/portal-task"
import { portalQueries } from "@/queries/portal"

export const Route = createFileRoute(
  "/$organisation/portal/_portal/tasks/$taskId/"
)({
  loader: async ({ context, params }) => {
    if (!context.linked) {
      return
    }

    const { tasks } = await context.queryClient.ensureQueryData(
      portalQueries.tasks()
    )

    if (!tasks.some((entry) => entry.id === params.taskId)) {
      throw notFound()
    }
  },
  component: PortalTaskPage,
})

function PortalTaskPage() {
  const { linked } = Route.useRouteContext()
  const { taskId } = Route.useParams()

  if (!linked) {
    return null
  }

  return (
    <PageHeaderSlotProvider>
      <div className="flex flex-col gap-8">
        <PortalTask key={taskId} taskId={taskId} />
      </div>
    </PageHeaderSlotProvider>
  )
}
